"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = configureStore;
const redux_1 = require("redux");
const redux_thunk_1 = __importDefault(require("redux-thunk"));
const reducers_1 = __importDefault(require("./reducers"));
// Compose redux with DevTools IF available.
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux_1.compose;
// Add seperate middleware as an array
const middleware = [redux_thunk_1.default];
// If redux-logger enabled, add to middleware (must be last in middleware array)
/*if (
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_SHOW_REDUX_LOGGER === "true"
) {
  const { createLogger } = require("redux-logger");

  const logger = createLogger({
    collapsed: true,
    duration: true,
  });

  middleware.push(logger);
}*/
// Export configured redux store.
function configureStore() {
    return (0, redux_1.createStore)(reducers_1.default, composeEnhancers((0, redux_1.applyMiddleware)(...middleware)));
}
